import { defineType } from "sanity";
import { multilingualStringPreview } from "../../base/multilingualArrayString";

export default defineType({
  name: "mainMenuExternalLink",
  title: "External Link",
  type: "object",
  preview: {
    select: {
      title: "title",
      image: "image"
    },
    prepare({ title, image }) {
      return {
        title: multilingualStringPreview(title),
        media: image
      };
    }
  },
  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "content",
      title: "Content",
      type: "multilingualArrayText",
      validation: (Rule) => Rule.required()
    },
    {
      name: "image",
      title: "Image",
      type: "image",
      validation: (Rule) => Rule.required()
    },
    {
      name: "externalLink",
      title: "External Link",
      type: "multilingualUrl",
      validation: (Rule) => Rule.required()
    },
    {
      name: "trackingName",
      title: "Tracking Name",
      type: "string"
    },
    {
      name: "filters",
      title: "Filters",
      description:
        "If present, the menu item will only appear for the below selected filters",
      type: "array",
      of: [
        {
          type: "locationFilter"
        }
      ]
    }
  ]
});
